import React from 'react'

export function StockInInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        html {
          --stock-in-form-font-size: 0.65em;
        }

        /*DROP DOWN MENU LIKE*/
        .action-btn-menu {
          position: absolute;
          top: 0;
          left: -60px;
          display: flex;
          justify-content: center;
          text-align: center;
          border-radius: 3px;
          font-size: 0.7em;
          z-index: 1;
          display: none;
        }
        .dd-menu { position: relative; }
        .show-dd-menu { display: flex; }

        .pospro-action-btn.edit-row-btn {
          background-color: rgba(0, 255, 0, 1);
          color: whitesmoke;
        }
        .pospro-action-btn.edit-row-btn:hover { background-color: rgba(0, 205, 0, 1); }

        .pospro-action-btn.del-row-btn {
          background-color: rgba(255, 0, 0, 1);
          color: whitesmoke;
        }
        .pospro-action-btn.del-row-btn:hover { background-color: rgba(205, 0, 0, 1); }
        /*DROP DOWN MENU LIKE END*/

        .stockin.pospro-action-btn {
          border-radius: 50px;
          padding: 5px;
        }

        .not-found {
          border: solid 2px red;
          background-color: lightgrey;
          color: darkgrey;
        }

        .not-found:focus {
          background-color: white;
          border: solid 0.5px lightblue;
          color: black;
        }

        .acl-container {
          position: relative;
          text-align: left;
          font-size: 16px;
          font-weight: normal;
        }

        #name-acl-container #autocomplete-list {
          bottom: 50%;
          margin-bottom: 33px;
        }

        .input-container {
          display: flex;
          flex-direction: column;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function StockInHeaderDetailsStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        #add-new-stock-header {
          margin: 10px 0;
        }
        #stock-in-form-container {
          /*background-color: blue;*/
          font-size: var(--stock-in-form-font-size);
          padding: 5px;
        }
        .stock-in-form .input-container {
          display: flex;
          flex: 5;
          align-self: center;
        }
        .stock-in-form {
          display: flex;
          margin: 5px;
          justify-content: space-between;
          width: 60%;
        }
        .stock-in-form label {
          /*text-align: right;*/
          font-weight: bold;
          margin-right: 5px;
          padding: 5px;
          /*font-size: var(--stock-in-form-font-size);*/
          flex: 2;
        }
        .stock-in-form input[type='date'] {
          font-family: arial;
        }
        .stock-in-form input {
          padding: 5px;
          border-radius: 3px;
          border: solid 0.5px lightblue;
          /*font-size: var(--stock-in-form-font-size);*/
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function StockInItemListStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
        {`
          #item-unit-quantity-container {
            border: 1px solid lightgrey;
            display: flex;
            flex-direction: column;
            justify-content: stretch;
            font-size: var(--stock-in-form-font-size);
          }
          #item-unit-quantity-container .table-header th {
            text-align: left;
            padding: 5px;
          }
          #item-unit-quantity-container td {
            padding: 7px;
          }
          #item-unit-quantity-container thead input, select {
            border: solid 1px lightgrey;
          }
          #item-unit-quantity-container th:nth-child(2) {
            width: 38%;
          }
          #item-unit-quantity-container th:nth-child(3) {
            width: 15%;
          }
          #item-unit-quantity-container th:nth-child(4) {
            width: 8%;
          }
          #item-unit-quantity-container th input, select {
            box-sizing: border-box;
            padding: 5px;
            width: 100%;
            height: 33px;
          }
          .highlight-item-details-row {
            background-color: lightblue;
          }
          input:read-only {
            background-color: lightgrey;
          }

          .expiration-date-input-container { display: flex; }
          .expiration-date-input-container label {
            flex: 0.8;
            margin: auto;
            font-size: 0.8em;
            text-align: left;
          }
          .expiration-date-input-container input[type='date'] { flex: 2; }

          .expiration-date-container {
            display: flex;
            font-size: 0.75rem;
            background-color: #888;
            border-radius: 5px;
            color: white;
            padding: 3px 6px;
            width: 160px;
            margin-top: 3px;
            text-align: center;
          }
          .expiration-date { color: lightgreen; }
        `}
      </style>
    </React.Fragment>
  )
}
